import { getCommands } from "src/modules/command/ajax/cloud";
import debug from "src/modules/debug-logger";
import commandFiles from "src/modules/command/command-files";
import { replaceCommands } from "../actions";

export default function synchronizeCommands() {
  return async (dispatch, getState) => {
    const commandsArray = await getCommands();
    const savedAudio = commandFiles.getFilenames();

    const promises = commandsArray.map(async ({ audioFile }) => {
      if (audioFile && !commandFiles.exists(audioFile.name)) {
        await commandFiles.download(audioFile);
      }
    });

    await Promise.all(promises);
    const commands = commandsArray.reduce(function arrayToObject(
      commandsObj,
      command
    ) {
      commandsObj[command.objectId] = command;
      return commandsObj;
    },
    {});
    dispatch(replaceCommands(commands));

    savedAudio?.forEach(function deleteIfUnused(filename) {
      const isInUse = commandsArray.some(({ audioFile }) => {
        return audioFile ? audioFile.name === filename : false;
      });
      if (isInUse === false) {
        debug.synchronizer("About to delete command audio", filename);
        commandFiles.delete(filename);
      }
    });
  };
}
